import type { AdminUserSearchUser } from '@/client/types/admin/users-orgs';

/**
 * The user-lookup panels (roles / permissions) key their loaded state off a
 * uid or authid in the URL, but the *display name* only exists on the picked
 * search result. To keep showing the name after a reload — without leaking the
 * person's name into the URL / browser history — the selected user is cached in
 * `sessionStorage` (per-tab, cleared when the tab closes) and rehydrated on
 * mount. These helpers wrap that access and swallow storage failures (private
 * mode, quota, disabled storage).
 */

export const readStoredUser = (key: string): AdminUserSearchUser | null => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as AdminUserSearchUser) : null;
  } catch {
    return null;
  }
};

export const writeStoredUser = (
  key: string,
  user: AdminUserSearchUser | null
): void => {
  try {
    if (user) sessionStorage.setItem(key, JSON.stringify(user));
    else sessionStorage.removeItem(key);
  } catch {
    /* ignore storage failures (private mode, quota, disabled) */
  }
};
